import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";

// Full VRIJMARKT wordmark (transparent webp) — includes the "Koop. Verkoop.
// Simpel." tagline, so no separate text is rendered. Size it either by `height`
// (desktop navbar) or by `widthClass` (large centered mobile header).
export function Logo({ height, widthClass, className = "" }) {
  return (
    <Link to="/" className={`flex items-center group ${className}`} data-testid="logo-link">
      <img
        src={logo}
        alt="VRIJMARKT — Koop. Verkoop. Simpel."
        style={height ? { height } : undefined}
        className={`${widthClass ? `${widthClass} h-auto` : "w-auto"} object-contain transition-transform duration-200 group-hover:scale-[1.03]`}
      />
    </Link>
  );
}
